<div class="content-login">
  <div class="login-form">
    <div class="mb-5 special">
      <p class="text-medium text-secondary">
        <span class="text-bold">¡Bienvenido!</span><br />
        Accediste al mundo Digital que <br />
        Seguros SURA creó para ti.
        <!-- <span class="text-bold">Grupo SURA</span> -->
      </p>
    </div>
    <div class="mb-5 pt-2">
      <form action="" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div>
          <input
            ngModel
            #email="ngModel"
            type="text"
            class="form-control"
            placeholder="Correo electrónico"
            (ngModelChange)="reset()"
            name="email"
            required
            pattern="([a-z0-9._%+-]|[A-Z0-9._%+-])+@([a-z0-9._%+-]|[A-Z0-9._%+-])+\.([a-z]|[A-Z]){2,4}$"
          />
          <small
            *ngIf="!email.valid && email.touched && email.value == ''"
            class="text-danger ml-2"
          >
            Campo obligatorio *</small
          >
          <small
            *ngIf="!email.valid && email.touched && email.value != ''"
            class="text-danger ml-2"
          >
            Correo no válido</small
          >
        </div>
        <div>
          <div class="input-icon">
            <i
              *ngIf="!show"
              class="fas fa-eye-slash lock"
              (click)="switchPass()"
            ></i>
            <i *ngIf="show" class="fas fa-eye lock" (click)="switchPass()"></i>
            <input
              ngModel
              type="password"
              [type]="show ? 'text' : 'password'"
              class="form-control"
              (ngModelChange)="reset()"
              placeholder="Contraseña"
              #password="ngModel"
              required
              name="password"
            />
          </div>
          <small
            *ngIf="!password.valid && password.touched"
            class="ml-2 text-danger"
          >
            Campo obligatorio *</small
          >
        </div>
        <div *ngIf="errorMessage">
          <small class="text-danger ml-2"> {{ errorMessage }}</small>
        </div>
        <div *ngIf="mensajeEmailVerificado != ''">
          <small class="text-success ml-2"> {{ mensajeEmailVerificado }}</small>
        </div>

        <div class="button-top mt-3">
          <a [routerLink]="'/recover-alianza'" class="mt-2"
            >¿Problemas al iniciar sesión?</a
          >
          <button
            class="btn btn-primary mt-1"
            type="submit"
            [disabled]="!loginForm.valid"
          >
            Iniciar sesión
          </button>
        </div>
      </form>
    </div>
    <div class="text-center mb-3 mt-5">
      <p class="text-body">¿Aún no eres proveedor de Seguros SURA</p>
      <p class="text-body">o no tienes cuenta de usuario?</p>
    </div>
    <div class="text-center">
      <button
        class="btn btn-outline-secondary"
        [routerLink]="'/register-alianza'"
      >
        REGÍSTRATE
      </button>
    </div>
  </div>
</div>
